<template>
   <div id="workspace">
   
   <simple-dialog ref="confirmDialog"
      :active="dialogActive" :hasOverlay="hasOverlay" :action="dialogAction" :data="tData">
        <template slot="title">{{dialogTitle}}</template>
        <template slot="message">{{dialogMessage}}</template>
        <template slot="buttons"></template>
   </simple-dialog>

   <div class="container">
        <div id="grid_toolbar">
        <button class="button" @click="$store.dispatch('loadCatalog','/data/jrecords.json');">Загрузить справочник</button>
        <span id="save" class="button">Сохранить проект</span>
        <span id="load" class="button">Загрузить проект</span>
        <span id="export-csv" class="button">экспорт в CSV</span>
        <span id="export-json" class="button">экспорт в JSON</span>
        <span id="calc-totals" @click="showDialog()" class="button">Посчитать итоги</span>
        </div>
   </div>


<!--

    <div>
        <button @click="$store.dispatch('loadCatalog','/data/jrecords.json');">load data</button>
        <button @click="loadTabulator()">load data 2</button>
        
        <select v-model="$store.state.selected" v-on:change="$store.dispatch('loadCatalog','/data/jrecords.json');">
            <option disabled value="0">Выберите базу данных</option>
            <option value="value1">ФСНТО2008</option>
            <option value="value2">ФСНТО2008-2</option>
        </select><span>Выбрано: {{$store.state.selected}}</span>
        <div><input type="number" v-model.number="$store.state.mynumber" />{{$store.state.mynumber}}</div>
    </div> -->
        
    <div class="columns">
        <div class="column is-3">
            <tabulator title="справочник" />
        </div>
        <div class="column"><keep-alive>
            <editor title="редактор" />        
            </keep-alive>
        </div>
    </div>
    </div>
</template>


<script>
//v-show="dialogActive"
//:title="dialogTitle" 
import Vue from 'vue';
import tabulator from './tabulator';
import editor from './editor';


import simpleDialog from './dialogs/simpleDialog';

export default {   
    name:'workspace',
    components:{tabulator, editor, simpleDialog},
    template: '<workspace/>',    
    data () {
        return {
            msg: 'workspace message',
            selected: '',
            dialogActive: false,
            dialogTitle: 'dlgTitle',
            dialogMessage: 'message',
            hasOverlay: true,
            tData: {id: 1, title: 'dataTitle'},
            dialogAction: function() {}
        }
    },
    
    computed:{
        activeDialog(){return this.dialogActive}
    },

    methods:{
        createUniqueString() {
            const uuid =()=>([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,c=>(c^crypto.getRandomValues(new Uint8Array(1))[0]&15 >> c/4).toString(16));
            return uuid();
        },

        prepareDialog(title, message, action){
            //this.dialogTitle = title;
            this.dialogTitle = this.$appName + ' ' + this.$appVersion;
            this.dialogMessage = message + this.createUniqueString();
            this.dialogAction = action;
        },

        modalAction(modal, result){
            this.dialogActive = false;
        },
        onModal(modal, result){
            console.dir('onModal');
            console.dir(modal);
            console.dir(result);
            this.dialogActive = false;
        },
        
        confirmDeleteRecord(){
            this.prepareDialog('Удалить', 'Удалить запись?', this.deleteRecord);
            this.$refs.confirmDialog.show();
        },
        
        deleteRecord(modal, result){
            if (result) {} console.dir('delete record');
            console.dir(modal);
            console.dir(result);
        },

        showDialog(action){
            this.confirmDeleteRecord();
            //simpleDialog.methods.Cancel();
           // simpleDialog.methods.showDialog();
            //this.dialogAction = this.modalAction;
            //this.dialogActive = true;
            
        },
        loadTabulator(){
            console.log(tabulator);
            console.log(this.$store.state.tableData);
            //tabulator.data.tableData = this.$store.state.tableData;
            //tabulator.data.tabulator.replaceData(this.$store.state.tableData);  
        }
    },

    mounted () {       
        //let app = this;
        //document.getElementById("calc-totals").onclick = function () {
        //console.dir(application);
        //app.$store.dispatch('loadCatalog','/data/jrecords.json');
      //};    
    }
}
</script>

<style>
#workspace{clear: both;}
</style>